export default __webpack_public_path__ + "static/media/gabig-banner-en.2d2c8446.webp";